'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const DEFAULT_ARTICLE_LIST = {
  layout: "grid",
  categoryIds: [],
  gridConfig: {
    row: 2,
    column: 4,
    gutter: 16
  },
  listConfig: {
    row: 10,
    gutter: 16
  },
  showLoadMore: true,
  commonStyle: { color: "#000000", backgroundColor: "#ffffff" }
};
const DEFAULT_ARTICLE_THUMBNAIL = "https://lh3.googleusercontent.com/nAocrNg5Uz_6OlemCdHXyNfPK9uxJpBhADfy_xEc4QiZT7ihSAC_8X_wkht7FGoOxRWfT0IFtkaVxF6mKajLbLbueDZmdlg=rw-w500";

exports.DEFAULT_ARTICLE_LIST = DEFAULT_ARTICLE_LIST;
exports.DEFAULT_ARTICLE_THUMBNAIL = DEFAULT_ARTICLE_THUMBNAIL;
